export default __webpack_public_path__ + "static/media/erase-svgrepo-com.d842f8ad.svg";